import { Component } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';

@Component({
  selector: 'jhi-my-quotations',
  templateUrl: './my-quotations.component.html',
})
export class MyQuotationsComponent {
  steps: Array<{ title: string; url: string }>;
  PATHS = PATHS;
  active = 1;

  constructor() {
    this.steps = [
      { title: 'baryApp.quotations.new.user-title', url: '/' + PATHS.USER_MY_QUOTATION_NEW.path },
      { title: 'baryApp.quotations.ongoing.user-title', url: '/' + PATHS.USER_MY_QUOTATION_ONGOING.path },
      { title: 'baryApp.quotations.old.title', url: '/' + PATHS.USER_MY_QUOTATION_OLD.path },
    ];
  }
}
